export default __webpack_public_path__ + "static/media/yumyum-widget-recommendation.3090aa54.webp";